
import { Component, Vue } from "vue-property-decorator";
import gql from "graphql-tag";
import AdminTable from "@/components/admin/AdminTable.vue";
import AdminSkinCell from "@/components/admin/AdminSkinCell.vue";
import AdminOfferStateBadge from "@/components/admin/AdminOfferStateBadge.vue";
import AdminProviderBadge from "@/components/admin/AdminProviderBadge.vue";
import AdminSteamBotSelector from "@/components/admin/AdminSteamBotSelector.vue";
import * as _ from "lodash";
import multipleMutate from "@/mixins/multipleMutate";
import SearchByFilter from "@/components/admin/SearchByFilter.vue";

@Component({
  components: {
    SearchByFilter,
    AdminTable,
    AdminSkinCell,
    AdminOfferStateBadge,
    AdminProviderBadge,
    AdminSteamBotSelector
  },
  mixins: [multipleMutate]
})
export default class AdminProviderOffer extends Vue {
  selected: any[] = [];
  // offerId -> предмет оффера (providerOfferItem: один предмет на оффер)
  offerItems: Record<string, any> = {};
  offerItemsLoading = false;

  columns = [
    {
      name: "_id",
      required: true,
      label: "name",
      field: "_id",
      align: "left",
      type: "string"
    },
    {
      // Не поле оффера: заполняется из providerOfferItem.
      // field — функция, чтобы колонка не попадала в фильтры поиска
      name: "item",
      required: true,
      label: "item",
      field: row => row._id,
      align: "left",
      type: "string"
    },
    {
      name: "price_RUB",
      required: true,
      label: "price_RUB",
      field: "price_RUB",
      align: "left",
      type: "number"
    },
    {
      name: "price_USD",
      label: "price_USD",
      field: "price_USD",
      align: "left",
      type: "number"
    },
    {
      name: "boughtPrice_USD",
      label: "boughtPrice_USD",
      field: "boughtPrice_USD",
      align: "left",
      type: "number"
    },
    {
      name: "offerId",
      align: "center",
      label: "offerId",
      field: "offerId",
      type: "string"
    },
    {
      name: "partnerUserId",
      align: "center",
      label: "partnerUserId",
      field: "partnerUserId",
      type: "string"
    },
    {
      name: "providerItemId",
      required: true,
      label: "providerItemId",
      field: "providerItemId",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "partnerItemId",
      required: true,
      label: "partnerItemId",
      field: "partnerItemId",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "appId",
      align: "center",
      label: "appId",
      field: "appId",
      type: "number"
    },
    {
      name: "botId",
      align: "center",
      label: "botId",
      field: "botId",
      type: "string"
    },
    {
      name: "partnerSteamId",
      align: "center",

      label: "partnerSteamId",
      field: "partnerSteamId",
      type: "string"
    },
    {
      name: "state",
      align: "center",
      label: "state",
      field: "state",
      editable: true,
      type: "number"
    },
    {
      name: "provider",
      align: "center",
      label: "provider",
      field: "provider",
      type: "string"
    },
    {
      name: "cancelReason",
      align: "left",
      label: "cancelReason",
      field: "cancelReason",
      type: "string"
    },
    {
      name: "createdAt",
      align: "center",
      label: "createdAt",
      field: "createdAt",
      type: "string"
    },
    {
      name: "updatedAt",
      align: "center",
      label: "updatedAt",
      field: "updatedAt",
      type: "string"
    },
    {
      name: "paymentId",
      align: "center",
      label: "paymentId",
      field: "paymentId",
      type: "string"
    },
    {
      name: "userId",
      align: "center",
      label: "userId",
      field: "userId",
      type: "string"
    },
    {
      name: "settlementAt",
      align: "center",
      label: "settlementAt",
      field: "settlementAt",
      type: "string"
    },
    {
      name: "tradeUrl",
      align: "center",
      label: "tradeUrl",
      field: "tradeUrl",
      type: "string"
    }
  ];

  // Steam присылает текст с <br> — показываем переносом строки
  formatCancelReason(value: string) {
    return String(value).replace(/<br\s*\/?>/gi, "\n");
  }

  get lastSelected() {
    return _.last(this.selected) || null;
  }

  // Догружаем предметы для офферов текущей страницы одним запросом
  async loadOfferItems(docs: any[]) {
    const ids = (docs || [])
      .map(doc => String(doc._id))
      .filter(id => !(id in this.offerItems));

    if (!ids.length) {
      return;
    }

    this.offerItemsLoading = true;

    try {
      const { data } = await this.$apollo.query({
        query: gql`
          query getModelDocs(
            $condition: JSON
            $modelName: String!
            $opts: JSON
          ) {
            getModelDocs(
              condition: $condition
              modelName: $modelName
              opts: $opts
            ) {
              docs
            }
          }
        `,
        variables: {
          modelName: "providerOfferItemModel",
          condition: { offerId: { $in: ids } },
          opts: {
            limit: ids.length,
            select: "offerId marketHashName image rarity phase float"
          }
        },
        fetchPolicy: "no-cache"
      });

      const items = { ...this.offerItems };
      (data?.getModelDocs?.docs || []).forEach(item => {
        items[String(item.offerId)] = item;
      });
      this.offerItems = items;
    } catch (error) {
      this.$q.notify({
        message: `Не удалось загрузить предметы офферов: ${error.message}`,
        multiLine: true,
        type: "negative"
      });
    } finally {
      this.offerItemsLoading = false;
    }
  }
}
